import * as fromContact from '../reducers/contactReducers'

export const getContact = (state) => fromContact.getContact(state.contact);
export const getContactList = (state) => fromContact.getContactList(state.contact);
export const getContactData = (state) => fromContact.getContactData(state.contact);
export const getContactLoading = (state) => fromContact.getContactLoading(state.contact);
export const getContactPagination = (state) => fromContact.getContactPagination(state.contact);
